import React from "react";
import { makeStyles } from "tss-react/mui";
const useStyles = makeStyles()((theme, { size = 16 }) => ({
    container: {
        display: "inline-flex",
        alignItems: "flex-end",
        gap: `${size * 0.15}px`,
        height: `${size}px`,
        padding: `${size * 0.125}px`,
    },
    bar: {
        width: `${size * 0.2}px`,
        borderRadius: `${size * 0.0625}px`,
        transition: "opacity 0.3s ease",
        backgroundColor: "currentColor",
    },
    bar1: {
        height: `${size * 0.3}px`,
    },
    bar2: {
        height: `${size * 0.55}px`,
    },
    bar3: {
        height: `${size * 0.8}px`,
    },
    active: {
        opacity: 1,
    },
    inactive: {
        opacity: 0.25,
    },
    colorGood: {
        color: theme.palette.success01,
    },
    colorMedium: {
        color: theme.palette.warning01,
    },
    colorPoor: {
        color: theme.palette.iconError,
    },
    colorLost: {
        color: theme.palette.ui05,
    },
    colorOther: {
        color: theme.palette.action01,
    },
}));
export const ConnectionIndicatorBars = ({ qualityLevel, isInactive, isInterrupted, size = 16 }) => {
    const { classes, cx } = useStyles({ size });
    // Determine color based on status
    let colorClass = classes.colorGood;
    if (isInactive) {
        colorClass = classes.colorOther;
    }
    else if (isInterrupted) {
        colorClass = classes.colorLost;
    }
    else if (qualityLevel === 0) {
        colorClass = classes.colorPoor;
    }
    else if (qualityLevel === 1) {
        colorClass = classes.colorMedium;
    }
    return (React.createElement("div", { className: cx(classes.container, colorClass) },
        React.createElement("div", { className: cx(classes.bar, classes.bar1, qualityLevel >= 0 ? classes.active : classes.inactive) }),
        React.createElement("div", { className: cx(classes.bar, classes.bar2, qualityLevel >= 1 ? classes.active : classes.inactive) }),
        React.createElement("div", { className: cx(classes.bar, classes.bar3, qualityLevel >= 2 ? classes.active : classes.inactive) })));
};
